import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const ContextFive = () => {
    return (
        <div className="App">
            <div className="App-body">
                <p>
                    Upon successfully recalling the correct detail about Nina, you input 
                    the password and gain access to the contents of the flash drive. The 
                    screen reveals a series of files and folders, each cryptically labeled 
                    in order. You realize the gravity of what you hold in your hands—information 
                    that could unravel the very fabric of Globex. With a deep breath, you begin 
                    to delve into the files, determined to uncover the truth Nina risked so 
                    much to protect.
                </p>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='/BoxThree/PuzzleFive'>Go to Puzzle Five</Button>
            </div>
        </div>
    );
  };

export default ContextFive;